import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Global } from 'src/app/_services/global.service';
import { LlmSettingService } from 'src/app/_services/llm-setting.service';
import { InfiniteGridComponent } from 'src/app/ui-library/component/infinite-grid/infinite-grid.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ModalService } from 'src/app/_services/modal.service';
import { SearchFormComponent } from 'src/app/ui-library/search-form/search-form.component';
import { LlmSettingItemComponent } from './llm-setting-item/llm-setting-item.component';

@Component({
  selector: 'app-llm-setting',
  templateUrl: './llm-setting.component.html',
  styleUrls: ['./llm-setting.component.css']
})
export class LlmSettingComponent extends InfiniteGridComponent {
  @ViewChild('SearchForm', { static: false }) SearchForm: SearchFormComponent

  llmSettingSource: Array<any>
  searchSection = [
    { name: 'ID', key: 'Id' },
  ]
  constructor(
    private llmSettingService: LlmSettingService,
    public global: Global,
    private toastr: ToastrService,
    private nzModalService: NzModalService,
    private modalService: ModalService
  ) {
    super(global)
  }


  setColumnDefs() {
    this.columnDefs = [
      { headerName: 'ID', field: 'id' },
      { headerName: 'Model Provider', field: 'modelProvider' },
      { headerName: 'Model ID', field: 'modelId' },
      { headerName: 'API Endpoint', field: 'apiEndpoint' },
      { headerName: 'API Key', field: 'apiKey' },
      {
        headerName: 'Is Actived',
        field: 'isActived',
        valueFormatter: (params: any) => {
          return params.value ? 'Yes' : 'No';
        }
      },
      {
        headerName: 'Action',
        pinned: 'right',
        minWidth: 120,
        cellRenderer: params => {
          return `<i class="fas fa-fw fa-circle-check grid-btn-icon ${params?.data?.isActived ? 'text-success' : 'text-secondary'}" id="active" style="margin-right:3px; cursor: pointer;"></i>
                      <i class="fas fa-fw fa-trash grid-btn-icon text-danger" id="delete" style="margin-right:3px; cursor: pointer;"></i>`;
        },
        onCellClicked: params => {
          switch (params.event.target.id) {
            case 'active':
              this.activateItem(params?.data?.id, params?.data?.isActived)
              break;
            case 'delete':
              this.modalService.createNzDeleteModal(() => this.delete.call(this, params?.data?.id))
              break;
          }
        },
      },
    ];
  }

  loadData() {
    this.gridApi.deselectAll();
    this.gridApi.purgeInfiniteCache();
  }

  ngOnInit() {
    this.setColumnDefs();
  }

  ngAfterViewInit() {
    this.setDatasource((prop: any) => this.llmSettingService.getLlmSettings(prop))
  }


  editItem(id: string) {
    this.llmSettingService.getLlmSettings({ Id: id }).subscribe(res => {
      const orgData = res.data[0]
      this.showItem(orgData)
    })
  }

  showItem(orgData?: any) {
    const modal = this.nzModalService.create({
      nzContent: LlmSettingItemComponent,
      nzBodyStyle: {
        'max-height': '70vh',
        'overflow-y': 'auto',
      },
      nzFooter: null,
      nzTitle: orgData ? 'Edit LLM Setting' : 'Create LLM Setting',
      nzComponentParams: {
        orgData: orgData,
      },
      nzWidth: 800
    });

    // Handle modal result
    modal.afterClose.subscribe(result => {
      if (result) {
        this.toastr.success(`Saved Successfully...!`, 'Success');
        this.loadData()
      }
    });
  }

  delete(id: string) {
    this.llmSettingService.deleteLlmSetting(id)
      .subscribe(() => {
        this.loadData();
        this.toastr.success('Data Deleted Successfully...!', 'Success');
      });
  }

  activateItem(id: string, currentIsActived: boolean) {
    if (currentIsActived) {
      this.toastr.info('No need to set again, it is already active');
      return
    }
    this.llmSettingService.setLlmSettingActived(id).subscribe(() => {
      this.loadData()
      this.toastr.success('Activated successfully', 'Success');
    });
  }
}